import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext'; // 👈 viktig
import './index.css';
import { CartProvider } from './context/CartContext';
import { ClearCartOnFlag } from "./context/ClearCartOnFlag";

ReactDOM.createRoot(document.getElementById('root')).render(
  <BrowserRouter>
    <AuthProvider>
      <CartProvider>      {/* 👈 WRAP CartProvider rundt App */}
                <ClearCartOnFlag />
        <App />
      </CartProvider>
    </AuthProvider>
  </BrowserRouter>
);
